(()=>{
  const STATES=[
    {m:0,t:'Night',d:'Low, warm light overnight.',l:'Night Light',c:[255,118,48],o:.12},
    {m:330,t:'Pre-dawn',d:'Low, warm light before wake time.',l:'Night Light',c:[255,126,56],o:.14},
    {m:390,t:'Wake',d:'Cooler light begins to brighten.',l:'Cooler · rising',c:[205,232,255],o:.52},
    {m:540,t:'Morning',d:'Cool, bright light for the morning.',l:'Cool · bright',c:[220,239,255],o:.74},
    {m:780,t:'Day',d:'Neutral, bright light through the day.',l:'Neutral · bright',c:[247,246,232],o:.84},
    {m:960,t:'Afternoon',d:'Neutral light begins to warm.',l:'Neutral · easing warm',c:[250,238,208],o:.76},
    {m:1050,t:'Late afternoon',d:'Warmer light begins to ease down.',l:'Warm · easing down',c:[255,208,155],o:.64},
    {m:1110,t:'Wind down',d:'Warm, dimmer light for the evening.',l:'Warm · dimmer',c:[255,182,104],o:.52},
    {m:1170,t:'Wind down',d:'Warm, dimmer light as the day winds down.',l:'Warm · dimmer',c:[255,151,72],o:.39},
    {m:1350,t:'Bed',d:'Night Light at low output.',l:'Night Light',c:[255,124,52],o:.18},
    {m:1440,t:'Night',d:'Low, warm light overnight.',l:'Night Light',c:[255,118,48],o:.12}
  ];

  const ENV=[
    {m:0,cool:0,warm:0,night:.86,bright:.24,sat:.72,hue:0},
    {m:330,cool:.18,warm:0,night:.68,bright:.32,sat:.76,hue:-8},
    {m:390,cool:.34,warm:0,night:.42,bright:.48,sat:.84,hue:-10},
    {m:540,cool:.28,warm:0,night:.08,bright:.84,sat:.92,hue:-8},
    {m:780,cool:.08,warm:0,night:0,bright:1.04,sat:1,hue:0},
    {m:960,cool:0,warm:.05,night:0,bright:.96,sat:1,hue:0},
    {m:1050,cool:0,warm:.16,night:.03,bright:.80,sat:1,hue:0},
    {m:1110,cool:0,warm:.24,night:.12,bright:.62,sat:.96,hue:1},
    {m:1170,cool:0,warm:.18,night:.40,bright:.40,sat:.88,hue:0},
    {m:1350,cool:0,warm:.03,night:.82,bright:.24,sat:.76,hue:0},
    {m:1440,cool:0,warm:0,night:.86,bright:.24,sat:.72,hue:0}
  ];

  const clamp=(v,a,b)=>Math.max(a,Math.min(b,v));
  const mix=(a,b,t)=>a+(b-a)*t;
  const pad=n=>String(n).padStart(2,'0');
  const fmt=m=>`${pad(Math.floor((m%1440)/60))}:${pad(m%60)}`;
  const normalize=m=>Math.round(((m%1440)+1440)%1440);

  function between(frames,m){
    m=normalize(m);
    let a=frames[0],b=frames[1];
    for(let i=0;i<frames.length-1;i++){
      if(m>=frames[i].m&&m<=frames[i+1].m){a=frames[i];b=frames[i+1];break;}
    }
    return {a,b,x:(m-a.m)/(b.m-a.m||1)};
  }

  function stateFor(m){
    const {a,b,x}=between(STATES,m);
    return {
      t:x<.5?a.t:b.t,
      d:x<.5?a.d:b.d,
      l:x<.5?a.l:b.l,
      c:a.c.map((v,i)=>Math.round(mix(v,b.c[i],x))),
      o:mix(a.o,b.o,x)
    };
  }

  function environmentFor(m){
    m=normalize(m);
    const {a,b,x}=between(ENV,m);
    const env={};
    for(const key of['cool','warm','night','bright','sat','hue'])env[key]=mix(a[key],b[key],x);
    return env;
  }

  function hydrateReference(root){
    const img=root?.querySelector('[data-circadian-reference-image]');
    const source=root?.querySelector('template[data-circadian-reference]');
    if(!img||!source||img.dataset.referenceHydrated==='1')return;
    const raw=(source.content?.textContent||source.innerHTML||source.textContent||'').trim();
    const prefix='data:image/jpeg;base64,';
    const encoded=(raw.startsWith(prefix)?raw.slice(prefix.length):raw).replace(/\s+/g,'');
    root.dataset.referenceSourceLength=String(raw.length);
    root.dataset.referenceEncodedLength=String(encoded.length);
    try{
      if(!encoded)throw new Error('missing embedded reference plate');
      const binary=atob(encoded),bytes=new Uint8Array(binary.length);
      for(let i=0;i<binary.length;i++)bytes[i]=binary.charCodeAt(i);
      const url=URL.createObjectURL(new Blob([bytes],{type:'image/jpeg'}));
      img.dataset.referenceHydrated='1';
      img.addEventListener('load',()=>{root.dataset.referenceReady='1';root.dataset.referenceError='';URL.revokeObjectURL(url);},{once:true});
      img.addEventListener('error',()=>{root.dataset.referenceError='image';URL.revokeObjectURL(url);},{once:true});
      img.src=url;
    }catch(error){
      root.dataset.referenceError='decode';
      root.dataset.referenceErrorName=error?.name||'Error';
      console.warn('WiZ Circadian reference plate could not be decoded.',error);
    }
  }

  function phaseFor(m){
    if(m<330)return'night';
    if(m<390)return'predawn';
    if(m<600)return'morning';
    if(m<960)return'day';
    if(m<1110)return'late-afternoon';
    if(m<1350)return'wind-down';
    return'bedtime';
  }

  function bind(root){
    if(!root)return;
    hydrateReference(root);
    if(root.dataset.bound==='1')return;
    root.dataset.bound='1';

    const visualRoot=root.closest('.section-wiz-circadian')||root;
    const setVar=(name,value)=>{root.style.setProperty(name,value);visualRoot.style.setProperty(name,value);};
    const dial=root.querySelector('[data-rhythm-dial]');
    const slider=root.querySelector('[data-rhythm-slider]');
    const nowBtn=root.querySelector('[data-rhythm-now]');
    const playBtn=root.querySelector('[data-rhythm-play]');
    const playLabel=root.querySelector('[data-rhythm-play-label]');
    const presets=[...root.querySelectorAll('[data-rhythm-preset]')];
    const timeEls=[...root.querySelectorAll('[data-rhythm-time],[data-rhythm-time-mirror]')];
    const titleEls=[...root.querySelectorAll('[data-rhythm-title],[data-rhythm-title-mirror]')];
    const lightEls=[...root.querySelectorAll('[data-rhythm-light],[data-rhythm-light-mirror]')];
    let minute=1110,playing=false,raf=0,last=0,drag=false;

    function render(m,source='render'){
      minute=normalize(m);
      const s=stateFor(minute),e=environmentFor(minute),time=fmt(minute);
      setVar('--wiz-r',s.c[0]);setVar('--wiz-g',s.c[1]);setVar('--wiz-b',s.c[2]);setVar('--wiz-output',s.o.toFixed(3));
      setVar('--r',s.c[0]);setVar('--g',s.c[1]);setVar('--b',s.c[2]);setVar('--out',s.o.toFixed(3));
      setVar('--env-cool',e.cool.toFixed(3));setVar('--env-warm',e.warm.toFixed(3));setVar('--env-night',e.night.toFixed(3));
      setVar('--scene-brightness',e.bright.toFixed(3));setVar('--scene-saturation',e.sat.toFixed(3));setVar('--scene-hue',`${e.hue.toFixed(1)}deg`);
      setVar('--sun-visible','0');setVar('--sun-show','0');
      setVar('--dial-angle',`${((minute/1440*360+180)%360).toFixed(2)}deg`);
      root.dataset.minute=String(minute);root.dataset.source=source;root.dataset.scenePhase=phaseFor(minute);root.dataset.wizOutput=s.o.toFixed(3);root.dataset.sunVisible='false';
      timeEls.forEach(el=>el.textContent=time);titleEls.forEach(el=>el.textContent=s.t);lightEls.forEach(el=>el.textContent=s.l);if(slider)slider.value=String(minute);
      if(dial){dial.setAttribute('aria-valuenow',String(minute));dial.setAttribute('aria-valuetext',`${time}, ${s.t}, ${s.l}`);}
      presets.forEach(btn=>btn.classList.toggle('is-active',Math.min(Math.abs(minute-Number(btn.dataset.rhythmPreset)),1440-Math.abs(minute-Number(btn.dataset.rhythmPreset)))<=8));
    }

    function fromPointer(ev){
      const r=dial.getBoundingClientRect(),x=ev.clientX-r.left-r.width/2,y=ev.clientY-r.top-r.height/2;
      let d=Math.atan2(y,x)*180/Math.PI+90;
      if(d<0)d+=360;
      const dayAngle=(d-180+360)%360;
      return Math.round(dayAngle/360*1440)%1440;
    }
    dial?.addEventListener('pointerdown',e=>{drag=true;dial.setPointerCapture?.(e.pointerId);render(fromPointer(e),'dial');});
    dial?.addEventListener('pointermove',e=>{if(drag)render(fromPointer(e),'dial');});
    dial?.addEventListener('pointerup',e=>{drag=false;dial.releasePointerCapture?.(e.pointerId);});
    dial?.addEventListener('pointercancel',()=>{drag=false;});
    dial?.addEventListener('keydown',e=>{
      const step=e.shiftKey?60:15;
      if(['ArrowRight','ArrowUp'].includes(e.key)){e.preventDefault();render(minute+step,'keyboard');}
      if(['ArrowLeft','ArrowDown'].includes(e.key)){e.preventDefault();render(minute-step,'keyboard');}
      if(e.key==='Home'){e.preventDefault();render(0,'keyboard');}
      if(e.key==='End'){e.preventDefault();render(1439,'keyboard');}
    });
    slider?.addEventListener('input',e=>render(Number(e.currentTarget.value),'native-range'));
    presets.forEach(btn=>btn.addEventListener('click',()=>render(Number(btn.dataset.rhythmPreset),'preset')));
    nowBtn?.addEventListener('click',()=>{const n=new Date();render(n.getHours()*60+n.getMinutes(),'now');});

    function setPlay(value){
      playing=value;playBtn?.setAttribute('aria-pressed',String(value));if(playLabel)playLabel.textContent=value?'Pause':'Play day';
      if(!value&&raf)cancelAnimationFrame(raf);if(value){last=performance.now();raf=requestAnimationFrame(tick);}
    }
    function tick(now){if(!playing)return;const dt=now-last;last=now;render(minute+dt*.15,'play');raf=requestAnimationFrame(tick);}
    playBtn?.addEventListener('click',()=>{if(matchMedia('(prefers-reduced-motion: reduce)').matches){render(minute+120,'play-step');return;}setPlay(!playing);});
    render(1110,'initial');
  }

  function init(scope=document){scope.querySelectorAll?.('[data-tls-wiz-circadian]').forEach(bind);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();